'use strict';

function isObjectType(obj, type) {
  return !!obj && (type || typeof obj) === 'object';
}

module.exports = isObjectType;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/isObjectType.js
// module id = 15
// module chunks = 0